import styled from '@emotion/styled';
import { laptop } from '../../../media';

export const SubHeading = styled.div`
  font-family: Custora;
  font-weight: 400;
  font-style: Regular;
  font-size: 18px;
  leading-trim: NONE;
  line-height: 27px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: #cccccc;
`;
export const Heading = styled.h1<{ isLight: boolean }>`
  font-family: Custora;
  font-weight: 500;
  font-style: Medium;
  font-size: 28px;
  leading-trim: NONE;
  line-height: 36px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: #e9ecf5;
  margin: 0;
`;

interface InfoTextProps {
  weight?: number;
  centered?: boolean;
  fontSize?: string;

  isLora?: boolean;
  isInter?: boolean;
}

export const InfoText = styled.p<InfoTextProps>`
  font-family: ${({ isInter, isLora }) => {
    if (isInter) return 'Inter, system-ui, -apple-system, BlinkMacSystemFont, sans-serif';
    if (isLora) return 'Custora, serif';
    return 'Custora, serif';
  }};

  font-weight: ${({ weight = 300 }) => weight};
  font-size: ${({ fontSize = '18px' }) => fontSize};
  line-height: 1.4;
  margin: 0;
  padding: 0;

  text-align: ${({ centered = false }) => (centered ? 'center' : 'left')};
  color: #e9ecf5;
`;

export const WhatYouNeedToKnow = styled.div`
  font-family: Custora;
  font-weight: 400;
  font-style: Regular;
  font-size: 18px;
  leading-trim: NONE;
  line-height: 140%;
  letter-spacing: 0px;
  vertical-align: middle;
  color: #e9ecf5;
`;
export const WhiteCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  background: white;
  width: 100%;
  padding: 24px 16px;
  border-radius: 9px;
  border: 1px solid #2b2d33;
  background: #1e1f22;
`;

export const CardAndIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: flex-start;
`;

export const Icon = styled.img`
  width: 25px;
  height: auto;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const RedirectLink = styled.a`
  font-family: Inter;
  font-weight: 600;
  font-style: Semi Bold;
  font-size: 15px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0px;
  vertical-align: middle;
  letter-spacing: 0px;
  cursor: pointer;
  text-decoration: none;
  color: #5e84ed;
  padding-top: 2px;
  &:hover {
    text-decoration: underline;
  }
`;

export const Breaker = styled.br`
  ${laptop`
  display:none
  `}
`;
